import React, { useEffect, useState } from "react";
import { AddToHomeScreen } from "react-pwa-add-to-homescreen";
import { connect } from "react-redux";
import {
	newAssortment,
	recentOrders,
} from "../../services/filteredResults/actions";
import HorizontalScroll from "./HorizontalScroll";
import SuppliersCarousel from "./SuppliersCarousel";

function Home(props) {
	const [recentlyOrderedProducts, setRecentlyOrderedProducts] = useState("");
	const [newAssortmentProducts, setNewAssortmentProducts] = useState("");

	useEffect(() => {
		recentOrders(
			props.loginSuccesful,
			props.identifyInfo.marketplace,
			props.identifyInfo.key,
			setRecentlyOrderedProducts
		);

		newAssortment(
			props.loginSuccesful,
			props.identifyInfo.marketplace,
			props.identifyInfo.key,
			setNewAssortmentProducts
		);
	}, []);

	return (
		<>
			<AddToHomeScreen
				translate={{
					safariTapShare: "Klik op delen",
					safariAddHomeScreen: "Kies 'Zet op beginscherm'",
					chromiumAddHomeScreen:
						"Klik 'Zet op beginscherm 'in het browser menu",
					chromiumInstall: "Het App Icon kunt u vinden op het beginscherm",
				}}
			/>
			<SuppliersCarousel />
			<HorizontalScroll
				data={recentlyOrderedProducts}
				title={"Recent besteld"}
			/>
			<HorizontalScroll
				data={newAssortmentProducts}
				title={"Nieuw in ons assortiment"}
			/>
		</>
	);
}

function mapStateToProps(state) {
	return {
		loginSuccesful: state.login.data.loginSuccesful,
		identifyInfo: state.identify.identifyInfo,
	};
}

export default connect(mapStateToProps, {})(Home);
